import React, {useCallback} from 'react';

//Hooks
import {useState, useEffect, useLayoutEffect, useRef} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

//Actions
import * as actions from '../../../../store/actions';

//Components
import {Container} from 'react-bootstrap';
import Loader from "react-loader-spinner";
import {Calendar} from "react-feather";
import { Redirect, useParams } from 'react-router-dom';
import ServiceOptions from "../../../../components/ServiceOptions/ServiceOptions";

//Styles
import Styles from './Events.module.scss';

//Utils
import moment from 'moment';

import { ROUTER_URL } from '../../../../const/ROUTER_URL';

const SCROLL_THRESHOLD = 100;

const Events = () => {
    const { shopId } = useParams();
    const events = useSelector(state => state.events.events);
    const first = useSelector(state => state.events.first);
    const loading = useSelector(state => state.events.loading);
    const noMoreEvents = useSelector(state => state.events.noMoreEvents);
    const { events: showEvents } = useSelector(state => state.companies.shop ? state.companies.shop.products : {});
    const dispatch = useDispatch();

    const ref = useRef();

    const [expanded, setExpanded] = useState(null);

    const { t } = useTranslation('common');

    const handleScroll = useCallback(/* istanbul ignore next */ () => {
        const bottom = ref.current.scrollHeight - ref.current.scrollTop - ref.current.clientHeight <= SCROLL_THRESHOLD;

        if (bottom && !loading && !noMoreEvents) {
            dispatch(actions.getEvents(first, 6));
        }
    }, [loading, first, ref, noMoreEvents, dispatch]);

    useEffect(() => {
        dispatch(actions.selectService(null));
        dispatch(actions.selectGroup(null));
        dispatch(actions.selectBundle(null));
    }, [dispatch]);

    useEffect(() => {
        dispatch(actions.getEvents(0, 6, true))
    }, [dispatch]);

    useLayoutEffect(() => {
        if (!ref.current) {
            return;
        }
        ref.current.addEventListener('wheel', handleScroll);
        ref.current.addEventListener('scroll', handleScroll);
        ref.current.addEventListener('touchmove', handleScroll, {passive: false});
        const container = ref.current;
        return /* istanbul ignore next */ () => {
            container.removeEventListener('wheel', handleScroll);
            container.removeEventListener('scroll', handleScroll);
            container.removeEventListener('touchmove', handleScroll, {passive: false});
        };
    }, [ref, handleScroll]);

    if (!showEvents) {
        return (
            <Redirect
                to={ROUTER_URL.SHOPS_ID_SUBSCRIPTIONS({ shopId })}
                exact
            />
        )
    }

    return (
        <Container ref={ref} className={Styles.container}>
            {loading && (
                <div className={Styles.infinityScroll}>
                    <Loader type="TailSpin" color="#000" height={25} width={25}/>
                </div>
            )}

            {events && events.length !== 0 && (
                <div className="w-100">
                    {events.map((event, index) => (
                        <React.Fragment key={`event-${event.id}`}>
                            {
                                index > 0 && events[index - 1] && (moment.unix(events[index - 1].time).utc().format('D MMMM') === moment.unix(events[index].time).utc().format('D MMMM')) ?
                                    null :
                                    <span className={Styles.title}>
                                    {moment.unix(event.time).utc().calendar(null, {
                                        sameDay: `[${t('homeScreen.events.today')}]`,
                                        nextDay: 'ddd D MMMM',
                                        lastWeek: 'ddd D MMMM',
                                        nextWeek: 'ddd D MMMM',
                                        sameElse: 'ddd D MMMM'
                                    })}
                                </span>
                            }
                            <ServiceOptions
                                event={event}
                                type={'event'}
                                to={ROUTER_URL.SHOPS_ID_EVENTS_ID({
                                    shopId,
                                    eventId: event.id,
                                })}
                                expanded={expanded === event.id}
                                onExpandChanged={() => setExpanded(event.id)}
                            />
                        </React.Fragment>
                    ))}
                </div>
            )}

            {loading && (
                <div className={Styles.infinityScroll}>
                    <Loader type="TailSpin" color="#000" height={25} width={25}/>
                </div>
            )}

            {!loading && events && events.length === 0 && (
                <div className={Styles.centeredContainer}>
                    <Calendar className={Styles.noEventsIcon} size={58}/>

                    <span className={Styles.noEventsMessage}>
                        {t('homeScreen.events.noEventsFound')}
                    </span>
                </div>
            )}
        </Container>
    )
};

export default Events
